<div class="flex-control flex-column">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">Note Component</li>
  </app-tabs>
  <app-note-components-listing class="flex-control flex-column" [hidden]="tabs_service.is_active()"></app-note-components-listing>
</div>
